export enum PreviewType {
  PHOTO = 'PHOTO',
  VIDEO = 'VIDEO',
}

export type Expert = {
  id: number;
  avatarUrl: string;
  bio: string;
  nickname: string;
  displayName: string;
  followersCount: string;
  createdAt: string;
  updatedAt: string;
};

export type AffiliationLink = {
  id: string;
  commissionPercent: string;
  description: string;
  link: string;
  points: number;
  rank: number;
  xesValue: number;
  createdAt: string;
  updatedAt: string;
};

export type Merchant = {
  id: number;
  affiliationLinks: AffiliationLink[];
  description: string;
  logo: string;
  name: string;
  rank: number;
  createdAt: string;
  updatedAt: string;
};

export type Product = {
  id: number;
  description: string;
  imageUrl: string;
  likesCount: string;
  merchant: Merchant;
  merchantId: number;
  price: string;
  title: string;
  wishesCount: string;
  url: string;
  createdAt: string;
  updatedAt: string;
};

export type Preview = {
  id: number;
  type: PreviewType;
  photoUrl?: string;
  videoUrl?: string;
  videoFirstFrameUrl?: string;
  videoThumbnailUrl?: string;
  createdAt: string;
  updatedAt: string;
};

export type Tag = {
  id: number;
  name: string;
  createdAt: string;
  updatedAt: string;
};

export type Collection = {
  id: number;
  category: string;
  code: string;
  description: string;
  expert: Expert;
  gender: string;
  products: Product[];
  publishAt: string | null;
  publishedAt: string | null;
  collectionPreview?: Preview;
  rank: string;
  status: string | 'PUBLISHED';
  tags: Tag[];
  title: string;
  totalLikes: string;
  totalShares: string;
  createdAt: string;
  updatedAt: string;
};
